import { useState } from 'react';
import { VscMenu } from 'react-icons/vsc';
import { Sidebar as ReactSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link } from 'react-router-dom';
import { ApiConfiguration } from '../../../features/apiReference/apiReferenceSlice';
import './Sidebar.scss';

const Sidebar = ({ apiConfiguration }: { apiConfiguration: ApiConfiguration }) => {
    const [toggled, setToggled] = useState(false);
    const [broken, setBroken] = useState(window.matchMedia('(max-width: 800px)').matches);

    const services = Object.entries(apiConfiguration).sort((a, b) => {
        const serviceA = a[0].toLowerCase();
        const serviceB = b[0].toLowerCase();
        if (serviceA < serviceB) return -1;
        if (serviceA > serviceB) return 1;
        return 0;
    });

    const menuItemStyles = {
        backgroundColor: '#562aa2',
        color: '#fff',
        button: {
            height: '42px',
            '&:hover': {
                backgroundColor: '#562aa2',
            },
            '&.active': {
                backgroundColor: '#562aa2',
            },
        },
        icon: {
            color: '#fff',
        },
        label: {
            color: '#fff',
        },
    };

    const subMenuItemStyles = {
        button: {
            height: '42px',
        }
    };

    return (
        <>
            <ReactSidebar className="vh-100 z-index-2" toggled={toggled} customBreakPoint="800px" onBreakPoint={setBroken} onBackdropClick={() => setToggled(false)}>
                <Menu menuItemStyles={menuItemStyles}>
                    <Link to="/" className="d-flex mx-3 py-3">
                        <img src="/Logo_Smash_API_Blanc.png" alt="" width={140}></img>
                    </Link>
                    <MenuItem component={<Link to="/docs" />} onClick={() => setToggled(false)}>Introduction</MenuItem>
                    <SubMenu label="API Reference" rootStyles={subMenuItemStyles}>
                        <MenuItem component={<Link to="/docs/APIReference" />} onClick={() => setToggled(false)}>Get started</MenuItem>
                        <SubMenu label="Services" rootStyles={subMenuItemStyles}>
                            {services.map(([service, config]) => (
                                <MenuItem key={service} component={<Link to={`/docs/APIReference/${service}`} />} onClick={() => setToggled(false)}>
                                    {service.charAt(0).toUpperCase() + service.slice(1)}
                                </MenuItem>
                            ))}
                        </SubMenu>
                    </SubMenu>
                    {/* <SubMenu label="SDKs">
                        <MenuItem component={<Link to="/docs/SDKReference" />} onClick={() => setToggled(false)}>Get started</MenuItem>
                    </SubMenu> */}
                </Menu>
            </ReactSidebar>
            <div className="bg-primary" style={{ minWidth: '64px', height: broken && !toggled ? '100vh' : '0px' }}>
                {(broken && !toggled) && (
                    <VscMenu className="mx-3 my-2 fw-bold text-white" size="2em" onClick={() => setToggled(!toggled)} style={{ cursor: 'pointer' }} />
                )}
            </div>
        </>
    )
}

export default Sidebar
